import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPadlockLocked = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4 5V4a4 4 0 1 1 8 0v1h2v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5zm2-1a2 2 0 1 1 4 0v1H6zm1 7V9h2v2z",
		clipRule: "evenodd"
	})
});
export default SvgPadlockLocked;
